import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const DataBox = styled.div.withConfig({ componentId: 'sc-1qeplx3-0' })`
    padding: ${size(1)} ${size(2)};
    background-color: var(--c-bg-alt);
    color: var(--_color);
    border-radius: ${(props) => props.theme.size.borderRadius};
    font-size: var(--font-size-small-static);
`;
